import React from 'react'

export const DSIHtml = ({
  value,
  as: Tag = 'span',
  ...props
}: import('./types').DangerouslySetInnerHtmlProps): JSX.Element => {
  return <Tag dangerouslySetInnerHTML={{ __html: value }} {...props} />
}
